// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_em-j";
export var fulfillmentFormRail = "_em-i";
export var headerTitleRow = "_em-l";
export var orderDetailsWrapper = "_em-g";
export var orderLinkTrigger = "_em-2";
export var paymentInformationGrid = "_em-q";
export var paymentSummaryColumn = "_em-r";
export var phoneShipmentPickerButton = "_em-e";
export var phoneShipmentPickerButtonContent = "_em-f";
export var phoneShipmentPickerButtonWrapper = "_em-d";
export var phoneShipmentPickerTrigger = "_em-c";
export var shipmentContainer = "_em-k";
export var shipmentDetailsMainPane = "_em-h";
export var shipmentNavigationCard = "_em-a";
export var shipmentNavigationEdgeTrigger = "_em-6";
export var shipmentNavigationRail = "_em-3";
export var shipmentNavigationRailEnter = "_em-5";
export var shipmentNavigationRailHeader = "_em-9";
export var shipmentNavigationRailOverlay = "_em-4";
export var shipmentNavigationScrim = "_em-7";
export var shipmentSummaryFact = "_em-n";
export var shipmentSummaryGrid = "_em-m";
export var shipmentSummaryMetadataRow = "_em-o";
export var shipmentSummaryTags = "_em-p";
export var shipmentWorkspace = "_em-0";
export var shipmentWorkspaceBodyTablet = "_em-8";
export var shipmentWorkspaceContent = "_em-b";
export var shipmentWorkspaceHeader = "_em-1";